<script setup lang="ts">
import SelectedBonusesDisplay2 from "@/components/RegistrationPage/PcVersion/SelectedBonusesDisplay2.vue";
import PaymentInfo from "@/components/RegistrationPage/Payment/PaymentInfo.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'SelectedBonuses',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },
    },

    watch: {
        selectedPass: {
            handler(): void
            {
                setTimeout(() => {
                    const el: HTMLDivElement = this.$refs.selectedBonuses as HTMLDivElement
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    })
                }, 100)
            },
        },
    },
})
</script>

<template>
    <div ref="selectedBonuses">
        <Transition name="fade" mode="out-in">
            <div class="panel d-flex flex-column justify-content-center align-items-center" v-if="selectedPass">
                <PaymentInfo/>

                <SelectedBonusesDisplay2 v-if="state.canPurchase && store.state.canPurchase"/>
            </div>
        </Transition>
    </div>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.05s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.list-move,
.list-enter-active,
.list-leave-active {
    transition: all 0.2s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateY(50px);
}

.list-leave-active {
    position: absolute;
}

p {
    margin: 0;
}

.row_1 {
    gap: 15px;
}

.titleLabel {
    width: 100%;
    background: rgba(0, 255, 255, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px 0 15px;
    font-size: 22px;
    color: #00bbff;
}

.paymentButton {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 128, 0, 0.3);
    color: #00ff00;
    border-radius: 10px;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.8);
    cursor: pointer;

    &:hover {
        background: rgba(0, 128, 0, 0.4);
    }

    &:active {
        background: rgba(0, 128, 0, 0.5);
    }
}


.panel {
    gap: 65px;
    width: fit-content;
}

.wrapper {
    position: relative;
    //background: black;
    //box-shadow: 0 0 15px 3px black;
    width: 100%;
    text-align: center;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    color: white;
    text-shadow: 2px 2px 5px black;
    background: rgba(0, 0, 0, 0.8);
    //margin-bottom: 100px;
    box-shadow: 0 0 25px 15px black;

    .content {
        width: fit-content;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        overflow: hidden;
        border-radius: 15px;
    }
}
</style>
